import { ExamUI } from '@shared';
import { useQuery } from '@tanstack/react-query';
import { examsApi } from 'App';

type Args = { exam: string };
type ExamTypes = examsApi.ExamAPI | ExamUI;

function isExamUI(exam: ExamTypes): exam is ExamUI {
  return Object.hasOwn(exam, 'name');
}

export function useExam({ exam }: Args): string {
  const { data } = useQuery(['exam', exam], () => examsApi.get(exam), {
    select: (exam: ExamTypes) => {
      if (isExamUI(exam)) {
        // when data comes from cached courses it's transformed for UI already
        return exam.name;
      }
      // when data comes from api request
      const { exam: examAPI } = exam;
      return examAPI.label;
    },
  });
  return data || 'Name was not found';
}
